<div *ngIf="groupToClone" style="width: 100%;">

<table id="clone-groupKey-table">
    <col width="25%">    
    <col width="20%">
    <col width="45%">
    <col width="10%">
    <tbody>
        <tr>
            <th colspan="4">
                <div style="text-align: center;">
                    Clone Reporting Group
                </div>               
            </th>
        </tr>
        <tr>
            <th>
                <div *ngIf="isDuplicate" style="color: red">
                    Duplicate
                </div>
            </th>
            <th>Group Key</th>
            <th>Name</th>
            <th></th>
        </tr>
        <tr>
            <td>Source Group To Clone</td>
            <td>{{groupToClone?.groupKey}}</td>
            <td>{{groupToClone?.name}}</td>
            <td></td>
        </tr>
        <tr>
            <td>New Cloned Group</td>
            <td>
                <input type="text" 
                        size="8"                        
                        tabindex="-1"                      
                        id="newGroupKey"
                        #newGroupKey
                        (input)="fieldChanged(newGroupKey)"
                        [appKeyboardDirectionalEvents]
                        (directionalEvent)="onDirectionEvent(newGroupKey, $event)"
                        />
            </td>
            <td>
                <input type="text" 
                        size="50"                        
                        tabindex="-1" 
                        #newGroupName
                        id="newGroupName"
                        (input)="fieldChanged(newGroupName)"
                        [appKeyboardDirectionalEvents]
                        (directionalEvent)="onDirectionEvent(newGroupName, $event)"
                        />
            </td>
            <td style="text-align: center;">
                <div *ngIf="getShowSaveButton()" class="action-buttons" 
                     ngbTooltip="Clone this Reporting Group Key">
                        <a (click)="cloneGroupKey()">
                            <i class="fa fa-save" style="color: blue"></i>                        
                        </a>
                </div>                
            </td>
        </tr>
    </tbody>
</table>
<p style="color:red; font-size: smaller;">{{errormessage}}</p>

</div>




